module.exports = "/assets/data/ff86403077370df720542211cf4f17d5-CT1.data.json";